import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import Tooltip from './Tooltip.js';
import '@babel/runtime-corejs3/core-js-stable/instance/fill';
import IcNFLogo from '../icons/IcNFLogo.js';
import IcTxtArrowDownSmallThin from '../icons/IcTxtArrowDownSmallThin.js';
import IcTxtArrowSmallThin from '../icons/IcTxtArrowSmallThin.js';
import { FOOTER_TYPE } from '../../constants/footer.js';
import { URL } from '../../constants/url.js';
import COLOR from '../../foundation/color.js';
import style from './FooterInfo.module.scss.js';

var _excluded = ["onClick"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, style);
function FooterInfoItem(_ref) {
  var title = _ref.title,
    description = _ref.description;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('item-info')
  }, /*#__PURE__*/React.createElement("dt", {
    className: cx('title')
  }, title), /*#__PURE__*/React.createElement("dd", {
    className: cx('description-info')
  }, description));
}
var getDescription = function getDescription(type) {
  switch (type) {
    case FOOTER_TYPE.MY_ASSET:
    case FOOTER_TYPE.PAYMENT:
      return /*#__PURE__*/React.createElement(React.Fragment, null, "\uB124\uC774\uBC84\uD30C\uC774\uB0B8\uC15C\u321C\uC740 \uC804\uC790\uACB0\uC81C\uC11C\uBE44\uC2A4\uC81C\uACF5\uC790 \uBC0F \uD1B5\uC2E0\uD310\uB9E4\uC911\uAC1C\uC790\uC774\uBA70 \uD1B5\uC2E0\uD310\uB9E4\uC758 \uB2F9\uC0AC\uC790\uAC00 \uC544\uB2D9\uB2C8\uB2E4. \uC0C1\uD488, \uC0C1\uD488\uC815\uBCF4 \uBC0F \uAC70\uB798\uC5D0 \uAD00\uD55C \uC758\uBB34\uC640 \uCC45\uC784\uC740 \uD310\uB9E4\uC790\uC5D0\uAC8C \uC788\uC2B5\uB2C8\uB2E4.");
    case FOOTER_TYPE.SAVINGS:
      return /*#__PURE__*/React.createElement(React.Fragment, null, "\uAE08\uC735\uC815\uBCF4\uB294 \uAE08\uC735\uC0AC \uACF5\uC2DC\uB97C \uAE30\uCD08\uB85C \uD55C \uCC38\uACE0\uC0AC\uD56D\uC774\uBA70, \uC774\uB294 \uC218\uC2DC\uB85C \uBCC0\uACBD\uB420 \uC218 \uC788\uC73C\uBBC0\uB85C, \uAC70\uB798 \uC804 \uD574\uB2F9 \uAE08\uC735\uC0AC\uC5D0 \uD655\uC778 \uBC14\uB78D\uB2C8\uB2E4.", /*#__PURE__*/React.createElement("br", null), "\uCD5C\uC885 \uC5C5\uB370\uC774\uD2B8 2023.01.31.");
    case FOOTER_TYPE.STOCK:
      return /*#__PURE__*/React.createElement(React.Fragment, null, "\uB124\uC774\uBC84\uD30C\uC774\uB0B8\uC15C\u321C\uAC00 \uC81C\uACF5\uD558\uB294 \uAE08\uC735 \uC815\uBCF4\uB294", ' ', /*#__PURE__*/React.createElement(Tooltip.Button, {
        showUnderline: true,
        tooltip: {
          position: 'bottom',
          contents: [{
            title: '네이버파이낸셜에 콘텐츠 제공',
            description: ( /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
              className: cx('item')
            }, /*#__PURE__*/React.createElement("em", {
              className: cx('name')
            }, "\uC5D0\uD504\uC564\uAC00\uC774\uB4DC"), " \uAE30\uC5C5 \uBC0F \uC7AC\uBB34\uC815\uBCF4"), /*#__PURE__*/React.createElement("li", {
              className: cx('item')
            }, /*#__PURE__*/React.createElement("em", {
              className: cx('name')
            }, "KG\uC81C\uB85C\uC778"), " \uD574\uC678 \uC2DC\uC138, \uC2DC\uC7A5\uC9C0\uD45C \uC815\uBCF4"), /*#__PURE__*/React.createElement("li", {
              className: cx('item')
            }, /*#__PURE__*/React.createElement("em", {
              className: cx('name')
            }, "\uBAA8\uB2DD\uC2A4\uD0C0"), " \uD574\uC678\uC885\uBAA9 \uB9AC\uC11C\uCE58"), /*#__PURE__*/React.createElement("li", {
              className: cx('item')
            }, /*#__PURE__*/React.createElement("em", {
              className: cx('name')
            }, "\uD55C\uAD6D\uC608\uD0C1\uACB0\uC81C\uC6D0"), " \uC8FC\uC8FC\uCD1D\uD68C\uC77C \uC815\uBCF4", ' '), /*#__PURE__*/React.createElement("li", {
              className: cx('item')
            }, /*#__PURE__*/React.createElement("em", {
              className: cx('name')
            }, "IR\uD050\uB354\uC2A4"), " \uAE30\uC5C5 IR \uC815\uBCF4"), /*#__PURE__*/React.createElement("li", {
              className: cx('item')
            }, /*#__PURE__*/React.createElement("em", {
              className: cx('name')
            }, "\uC9C0\uC18D\uAC00\uB2A5\uBC1C\uC804\uC18C"), " \uBE44\uC7AC\uBB34\uC815\uBCF4"), /*#__PURE__*/React.createElement("li", {
              className: cx('item')
            }, /*#__PURE__*/React.createElement("em", {
              className: cx('name')
            }, "\uC778\uD3EC\uC2A4\uD0C1"), " \uAD6D\uB0B4 \uD14C\uB9C8, \uD574\uC678 \uBD84\uC11D \uC815\uBCF4"), /*#__PURE__*/React.createElement("li", {
              className: cx('item')
            }, /*#__PURE__*/React.createElement("em", {
              className: cx('name')
            }, "\uC5C5\uBE44\uD2B8"), " \uAC00\uC0C1\uC790\uC0B0 \uC2DC\uC138 \uC815\uBCF4"), /*#__PURE__*/React.createElement("li", {
              className: cx('item')
            }, /*#__PURE__*/React.createElement("em", {
              className: cx('name')
            }, "\uBE57\uC378"), " \uAC00\uC0C1\uC790\uC0B0 \uC2DC\uC138 \uC815\uBCF4")))
          }, {
            title: '네이버에 콘텐츠 제공',
            description: ( /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
              className: cx('item')
            }, /*#__PURE__*/React.createElement("em", {
              className: cx('name')
            }, "\uCF54\uC2A4\uCF64"), " \uAD6D\uB0B4 \uC2DC\uC138 \uC815\uBCF4"), /*#__PURE__*/React.createElement("li", {
              className: cx('item')
            }, /*#__PURE__*/React.createElement("em", {
              className: cx('name')
            }, "\uB808\uD53C\uB2C8\uD2F0\uBE0C"), " \uD574\uC678\uC885\uBAA9/\uC9C0\uC218 \uC2DC\uC138, \uC7AC\uBB34, \uC2DC\uC7A5\uC9C0\uD45C \uC815\uBCF4")))
          }]
        }
      }, "\uCF58\uD150\uCE20 \uC81C\uACF5\uC5C5\uCCB4"), "\uB85C\uBD80\uD130 \uBC1B\uB294 \uC815\uBCF4\uB85C \uD22C\uC790 \uCC38\uACE0\uC0AC\uD56D\uC774\uBA70, \uC624\uB958\uAC00 \uBC1C\uC0DD\uD558\uAC70\uB098 \uC9C0\uC5F0\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uB124\uC774\uBC84\uD30C\uC774\uB0B8\uC15C\u321C\uB294 \uC81C\uACF5\uB41C \uC815\uBCF4\uC5D0 \uC758\uD55C \uD22C\uC790\uACB0\uACFC\uC5D0 \uBC95\uC801\uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uAC8C\uC2DC\uB41C \uC815\uBCF4\uB294 \uBB34\uB2E8\uC73C\uB85C \uBC30\uD3EC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.");
    case FOOTER_TYPE.REAL_ESTATE:
      return /*#__PURE__*/React.createElement(React.Fragment, null, "\uB124\uC774\uBC84\uD30C\uC774\uB0B8\uC15C(\uC8FC)\uAC00 \uC81C\uACF5\uD558\uB294 \uBD80\uB3D9\uC0B0 \uC815\uBCF4\uB294 \uAC01 \uCF58\uD150\uCE20 \uC81C\uACF5\uC5C5\uCCB4\uB85C\uBD80\uD130 \uBC1B\uB294 \uC815\uBCF4\uB85C \uCC38\uACE0\uC6A9\uC785\uB2C8\uB2E4. \uC815\uBCF4\uC758 \uC815\uD655\uC131\uC774\uB098 \uC2E0\uB8B0\uC131\uC744 \uBCF4\uC99D\uD558\uC9C0 \uC54A\uC73C\uBA70, \uC11C\uBE44\uC2A4 \uC774\uC6A9\uC758 \uACB0\uACFC\uC5D0 \uB300\uD574\uC11C \uC5B4\uB5A0\uD55C \uBC95\uC801\uC778 \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uAC8C\uC2DC\uB41C \uC815\uBCF4\uB294 \uBB34\uB2E8 \uBCF5\uC81C\xB7\uBC30\uD3EC\xB7\uC804\uC1A1(\uBC18\uBCF5\uC801\uC774\uAC70\uB098 \uD2B9\uC815 \uBAA9\uC801\uC744 \uC704\uD55C \uCCB4\uACC4\uC801\uC778 \uAC83\uC744 \uD3EC\uD568\uD569\uB2C8\uB2E4) \uB4F1 \uC774\uC6A9\uD560 \uC218 \uC5C6\uC73C\uBA70, \uC774\uB97C \uBB34\uB2E8 \uC774\uC6A9\uD558\uB294 \uACBD\uC6B0 \uC800\uC791\uAD8C\uBC95 \uB4F1\uC5D0 \uB530\uB77C \uBC95\uC801 \uCC45\uC784\uC744 \uC9C8 \uC218 \uC788\uC2B5\uB2C8\uB2E4.");
    default:
      return null;
  }
};
function FooterInfo(_ref2) {
  var _overrideInfo$descrip, _overrideInfo$NFBusin;
  var logoColor = _ref2.logoColor,
    textColor = _ref2.textColor,
    type = _ref2.type,
    openNewWindow = _ref2.openNewWindow,
    overrideInfo = _ref2.overrideInfo;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showInfo = _useState2[0],
    setShowInfo = _useState2[1];
  var description = (_overrideInfo$descrip = overrideInfo === null || overrideInfo === void 0 ? void 0 : overrideInfo.description) !== null && _overrideInfo$descrip !== void 0 ? _overrideInfo$descrip : getDescription(type);
  var _ref3 = (_overrideInfo$NFBusin = overrideInfo === null || overrideInfo === void 0 ? void 0 : overrideInfo.NFBusinessInfo) !== null && _overrideInfo$NFBusin !== void 0 ? _overrideInfo$NFBusin : {},
    onClickNFBusinessInfo = _ref3.onClick,
    restNFBusinessIfnoProps = _objectWithoutProperties(_ref3, _excluded);
  var handleInfoButton = function handleInfoButton(event) {
    onClickNFBusinessInfo === null || onClickNFBusinessInfo === void 0 || onClickNFBusinessInfo(event);
    setShowInfo(!showInfo);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', "type-".concat(textColor))
  }, /*#__PURE__*/React.createElement("a", _objectSpread({
    href: URL.NAVER_FINANCIAL,
    className: cx('link'),
    target: openNewWindow ? '_blank' : '_self',
    rel: openNewWindow ? 'noreferrer noopener' : undefined
  }, overrideInfo === null || overrideInfo === void 0 ? void 0 : overrideInfo.logo), /*#__PURE__*/React.createElement(IcNFLogo, {
    width: 96,
    height: 26,
    fill2: COLOR[logoColor].color
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "Naver Financial")), description && /*#__PURE__*/React.createElement("div", {
    className: cx('description')
  }, description), /*#__PURE__*/React.createElement("div", {
    className: cx('area-fold')
  }, /*#__PURE__*/React.createElement("button", _objectSpread({
    type: "button",
    className: cx('button', {
      'is-open': showInfo
    }),
    onClick: handleInfoButton
  }, restNFBusinessIfnoProps), "\uB124\uC774\uBC84\uD30C\uC774\uB0B8\uC15C\u321C \uC0AC\uC5C5\uC790 \uC815\uBCF4", /*#__PURE__*/React.createElement("span", {
    className: cx('icon')
  }, /*#__PURE__*/React.createElement(IcTxtArrowDownSmallThin, {
    width: 8,
    height: 4,
    fill: COLOR.gray700.color
  }), showInfo ? /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uC811\uAE30") : /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uD3BC\uCE58\uAE30"))), showInfo && ( /*#__PURE__*/React.createElement("dl", {
    className: cx('info')
  }, /*#__PURE__*/React.createElement(FooterInfoItem, {
    title: "\uB300\uD45C\uC774\uC0AC",
    description: /*#__PURE__*/React.createElement(React.Fragment, null, "\uBC15\uC0C1\uC9C4")
  }), /*#__PURE__*/React.createElement(FooterInfoItem, {
    title: "\uC8FC\uC18C",
    description: /*#__PURE__*/React.createElement(React.Fragment, null, "\uACBD\uAE30\uB3C4 \uC131\uB0A8\uC2DC \uBD84\uB2F9\uAD6C \uC815\uC790\uC77C\uB85C 95, ", /*#__PURE__*/React.createElement("br", null), "NAVER 1784")
  }), /*#__PURE__*/React.createElement(FooterInfoItem, {
    title: "\uC804\uD654",
    description: /*#__PURE__*/React.createElement(React.Fragment, null, "1588-3819 (\uB300\uD45C\uC804\uD654/\uACE0\uAC1D\uC13C\uD130)")
  }), /*#__PURE__*/React.createElement(FooterInfoItem, {
    title: "\uBB38\uC758",
    description: /*#__PURE__*/React.createElement("a", _objectSpread({
      href: URL.HELP,
      className: cx('link-blue'),
      target: openNewWindow ? '_blank' : '_self',
      rel: openNewWindow ? 'noreferrer noopener' : undefined
    }, overrideInfo === null || overrideInfo === void 0 ? void 0 : overrideInfo.cs), "1:1 \uBB38\uC758 \uBC14\uB85C\uAC00\uAE30", /*#__PURE__*/React.createElement("span", {
      className: cx('icon')
    }, /*#__PURE__*/React.createElement(IcTxtArrowSmallThin, {
      width: 4,
      height: 8,
      fill: COLOR.blue500.color
    })))
  }), /*#__PURE__*/React.createElement(FooterInfoItem, {
    title: "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638",
    description: /*#__PURE__*/React.createElement(React.Fragment, null, "524-86-01528")
  })))));
}

export { FooterInfo as default };
